export const ProjectFundRouting = [
  {
    path: "/finance/project-fund/list",
    name: "basic-finance-project-fund-list",
    meta: { title: "工程款项科目设置" },
    component: () =>
      import(
        /* webpackChunkName: "basic-finance-project-fund" */ "@/views/finance/project-fund/list/index.vue"
      ),
  },
];
